import { Procedure } from '@medplum/fhirtypes';
import { TherapeuticServiceFormData } from '@/pages/ainigma/patient/examination/therapeuticServices/TherapeuticServiceModal';

export const mapProcedureToTherapeuticService = (
  procedure: Procedure
): TherapeuticServiceFormData => {
  // Get start date from performedPeriod.start or performedDateTime
  let startDate: Date | null = null;
  if (procedure.performedPeriod?.start) {
    startDate = new Date(procedure.performedPeriod.start);
  } else if (procedure.performedDateTime) {
    startDate = new Date(procedure.performedDateTime);
  }

  // Get termination date from performedPeriod.end
  let terminationDate: Date | null = null;
  if (procedure.performedPeriod?.end) {
    terminationDate = new Date(procedure.performedPeriod.end);
  }

  // Extract response/notes from procedure.note
  const response = procedure.note?.[0]?.text || '';

  return {
    id: procedure.id,
    service: procedure.code,
    startDate,
    terminationDate,
    response,
    status: procedure.status,
    encounterId: procedure.encounter?.reference?.split('/')[1],
  };
};
